var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.klass },
    [_c("columns-list", { attrs: { columns: _vm.options.options } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }